import { Typography, Box, Container, Button, Paper, Chip } from '@mui/material';
import { ShoppingCart } from '@mui/icons-material';
import React from 'react';

type Props = {};

const ANationsCryPageLayout = (props: Props) => {
  return (
    <Container maxWidth="lg" sx={{ py: { xs: 4, md: 6 } }}>
      <Box sx={{ 
        display: 'flex', 
        flexDirection: { xs: 'column', md: 'row' },
        gap: 4,
        mb: 4
      }}>
        {/* Book Image Section */}
        <Box sx={{ 
          flex: { xs: '1', md: '0 0 40%' },
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start'
        }}>
          <Paper
            elevation={4}
            sx={{
              overflow: 'hidden',
              borderRadius: 2,
              maxWidth: '400px',
              width: '100%'
            }}
          >
            <img 
              src='/A_Nations_cry.jpg' 
              alt='A Nations Cry by Philip Payne'
              style={{
                width: '100%',
                height: 'auto',
                display: 'block'
              }}
            />
          </Paper>
        </Box>

        {/* Book Details Section */}
        <Box sx={{ flex: 1 }}>
          <Typography 
            variant="h1" 
            sx={{ 
              fontSize: { xs: '2.5rem', md: '3.5rem' },
              fontWeight: 700,
              color: '#2c3e50',
              mb: 1,
              fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
            }}
          >
            A Nation's Cry
          </Typography>
          
          <Box sx={{ mb: 3 }}>
            <Chip 
              label="ISBN: 979-8323680931" 
              sx={{ 
                backgroundColor: '#ecf0f1',
                color: '#2c3e50',
                fontFamily: 'monospace',
                fontSize: '0.9rem'
              }} 
            />
          </Box>

          <Button
            variant="contained"
            startIcon={<ShoppingCart />}
            href="https://www.amazon.co.uk/Nations-Cry-Philip-Payne/dp/B0D2V4LXW8"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              backgroundColor: '#e74c3c',
              px: 4,
              py: 1.5,
              fontSize: '1.1rem',
              mb: 4,
              '&:hover': {
                backgroundColor: '#c0392b'
              },
              textTransform: 'none',
              fontWeight: 600
            }}
          >
            Purchase on Amazon
          </Button>

          <Paper
            elevation={0}
            sx={{
              p: 3,
              backgroundColor: 'white',
              borderRadius: 2,
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
            }}
          >
            <Typography
              variant="h3"
              sx={{
                fontSize: { xs: '1.5rem', md: '1.75rem' },
                fontWeight: 600,
                color: '#2c3e50',
                mb: 2,
                fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
              }}
            >
              About the Book
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: '1rem', md: '1.125rem' },
                lineHeight: 1.9,
                color: '#444',
                fontFamily: 'Georgia, serif'
              }}
            >
              After centuries of peace, Tagonia suspects trouble may be brewing from its neighbour, just across the sea. The emperor Marciarnous, although he would never admit it, is losing his control over his ambitious eldest son. Xantos, Ruler of Southern Mensk, has built an army far greater than that of his ageing father's in the North and is now desperate for conquest. No longer interested in peace, Xantos is unwilling to wait until he inherits the title of emperor before pushing forward with his plans.
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: '1rem', md: '1.125rem' },
                lineHeight: 1.9,
                color: '#444',
                fontFamily: 'Georgia, serif',
                mt: 2
              }}
            >
              The king of Tagonia is also nearing the end of his time but with his daughter and sole heir unprepared for the crown, things are looking bleak. Even with no real army to speak of and nothing more than a country full of crafters and farmers, the new queen is determined not to surrender the nation without a good fight.
            </Typography>
          </Paper>
        </Box>
      </Box>
    </Container>
  );
};

export default ANationsCryPageLayout;
